import { render, staticRenderFns } from "./npl-xfswg.vue?vue&type=template&id=438f5d49&scoped=true"
import script from "./npl-xfswg.vue?vue&type=script&lang=js"
export * from "./npl-xfswg.vue?vue&type=script&lang=js"
import style0 from "./npl-xfswg.vue?vue&type=style&index=0&id=438f5d49&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f5d49",
  null
  
)

export default component.exports